export const transformContentToCarouselItems = (content, language, operator, ppvEvents, ppvSubscribedList) => {
    const carouselContent = [];
    content
        .filter((item) => {
            const operators = item?.allowedOperators?.length > 0 ? item.allowedOperators : [];
            const hasValidImages = item.imageUrls?.some(
                (img) =>
                    (img.key === 'background' && (img.url || (language === 'ar' ? img.urlAr : img.url))) ||
                    (img.key === 'title' && (img.url || (language === 'ar' ? img.urlAr : img.url)))
            );
            return hasValidImages && (operators.length === 0 || operators.includes(operator));
        })
        .forEach((item) => {
            const backgroundImage = item.imageUrls.find((img) => img.key === 'background');
            const titleImage = item.imageUrls.find((img) => img.key === 'title');

            const logoUrl =
                language === 'ar'
                    ? titleImage?.urlPNGAdaptive || titleImage?.urlAr || titleImage?.url || ''
                    : titleImage?.urlPNGAdaptive || titleImage?.url || '';

            const poster =
                language === 'ar' ? backgroundImage?.urlAr || backgroundImage?.url || '' : backgroundImage?.url || '';

            if (poster.length <= 0) return;

            const ppvEvent = ppvEvents.find((event) => event?.subscriptionGuid === item?.subscriptionGuid);
            const isPPvSubscribed =
                ppvSubscribedList.length > 0 && ppvSubscribedList.some((sub) => sub?.eventId === ppvEvent?.eventId);
            if (ppvEvent?.subscriptionGuid) {
                carouselContent.push({
                    mainImage: poster,
                    logo: logoUrl,
                    bannerType: item.bannerType,
                    subscriptionGuid: item.subscriptionGuid,
                    url: item?.url,
                    isPPvSubscribed,
                });
            }
        });
    const sortedCarouselContent = carouselContent.sort((a, b) => {
        if (a.isPPvSubscribed && !b.isPPvSubscribed) return 1;
        if (!a.isPPvSubscribed && b.isPPvSubscribed) return -1;
        return 0;
    });
    return sortedCarouselContent;
};
